export default __webpack_public_path__ + "static/media/evenShotMascot.99715fc0.png";